import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { format } from 'date-fns';
import {
	Button,
	Div,
	InputGroup,
	Typography,
} from '@icecreamsocial/components';
import {
	QuerySearchBar,
	Pagename,
	PopsicleLoader,
} from '../../../../../../../../presentational';
import FilterForm from './components/FilterForm';
import { RewardsFiltersProvider } from './components/FilterProvider';
import { Table } from './components/Table';
import { ExportButton } from './components/ExportButton';
import { useCampaign } from '../../../../providers/Campaign';

const Rewards = () => {
	const { campaignId } = useParams();
	const { campaign } = useCampaign();
	const { data } = campaign;

	return (
		<RewardsFiltersProvider>
			<Div display='flex'>
				<Div elWidth='100%'>
					<Div
						display='flex'
						alignItems='center'
						justifyContent='space-between'
					>
						<Pagename>Rewards</Pagename>
						<ExportButton />
					</Div>
					<Div>
						<QuerySearchBar
							id='rewardSearch'
							name='search'
							placeholder='Find Rewards'
						/>

						{data ? (
							<Table campaignId={campaignId} campaign={data} />
						) : (
							<Div
								display='flex'
								padding='xlg'
								elMinHeight='300px'
								alignItems='center'
								justifyContent='center'
								flexDirection='column'
								backgroundColor='bodyInverse'
								borderRadius='default'
								borderColor='ambient'
								border='1px solid'
							>
								<PopsicleLoader />
								<Typography.P margin='none' textColor='ambientDark'>
									Just a moment...
								</Typography.P>
							</Div>
						)}
					</Div>
				</Div>
				<Div as='aside' elWidth='25%' marginLeft='lg' marginBottom='lg'>
					<Div position='sticky' positionTop='0'>
						<FilterForm />
					</Div>
				</Div>
			</Div>
		</RewardsFiltersProvider>
	);
};

Rewards.displayName = 'Campaigns.Campaign.Reports.Rewards';
export default observer(Rewards);
